<template>
  <v-dialog v-model="show" persistent max-width="590">
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip bottom transition="none" color="black">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon depressed
            @click="show=true"
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
            >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Regenerate</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>Regenerate</v-card-title>
      <v-card-text>
        <p>This will generate new predictions, replacing the current output.</p>
        <v-checkbox v-model="recompile" label="Refresh files and dataset" hint="This may take a while depending on size of data." persistent-hint />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onSubmit(false)">
          Cancel
        </v-btn>
        <v-btn color="error" text @click="onSubmit(true)">
          Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "Confirm",
  data () {
    return {
      show: false,
      recompile: false,
    }
  },
  methods: {
    onSubmit(accept=false) {
      if (accept) {
        this.$emit('confirmed', this.recompile)
      }
      this.show = false 
    }
  }
}
</script>